export const apps = [
  {
    name: 'Index',
    url: '/apps/',
    icon: 'icon-home'
  },
  {
    name: 'Create App',
    url: '/apps/create',
    icon: 'icon-plus'
  }
];
